import { s3ThemeAssetUrl, themeAssetUrl } from "./themeAssets";

const MOBILE_MQ = "(max-width: 768px)";

export function isMobileViewport() {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }
  return window.matchMedia(MOBILE_MQ).matches;
}

/** Pick mobile or desktop background with cross-fallback when one asset is missing. */
export function getThemeBackgroundFile(themeData) {
  if (!themeData) return "";
  const desk = themeData.background_desk || themeData.backgroundDesk || "";
  const mob = themeData.background_mob || themeData.backgroundMob || "";
  if (isMobileViewport()) {
    return mob || desk;
  }
  return desk || mob;
}

export function applyThemeBodyBackground(themeData) {
  if (typeof document === "undefined" || !themeData) return;

  const body = document.body;
  const file = getThemeBackgroundFile(themeData);
  const desk = themeData.background_desk || themeData.backgroundDesk || "";
  const mob = themeData.background_mob || themeData.backgroundMob || "";
  const mobile = isMobileViewport();
  const key = mobile ? (mob ? "background_mob" : "background_desk") : (desk ? "background_desk" : "background_mob");
  const url = themeAssetUrl(themeData, key) || s3ThemeAssetUrl(file);

  if (!url) {
    body.style.backgroundImage = "";
    return;
  }

  body.style.backgroundImage = `url(${url})`;
  body.style.backgroundSize = "100% 100%";
  body.style.backgroundPosition = "center center";
  body.style.backgroundRepeat = "no-repeat";
  body.style.backgroundAttachment = mobile ? "scroll" : "fixed";
  body.style.minHeight = mobile ? "100dvh" : "100vh";
}

export function clearThemeBodyBackground() {
  if (typeof document === "undefined") return;
  const body = document.body;
  body.style.backgroundImage = "";
  body.style.backgroundSize = "";
  body.style.backgroundPosition = "";
  body.style.backgroundRepeat = "";
  body.style.backgroundAttachment = "";
  body.style.minHeight = "";
}
